import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {PearlHarbor} from "../PearlHarbor";
import {TimelineLite, TweenLite, gsap} from "gsap";
import {Icon} from "@nolimitcity/slot-launcher/bin/gui/displayobjects/Icon";
import {PointerStateIconSet} from "@nolimitcity/slot-launcher/bin/gui/buttons/states/sets/PointerStateIconSet";
import {PearlHarborGameAssets} from "../PearlHarborGameAssets";
import {PointerStateColorSet} from "@nolimitcity/slot-launcher/bin/gui/buttons/states/sets/PointerStateColorSet";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {BetBoostData} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetHandler";
import {PearlHarborSoundManager} from "../sound/PearlHarborSoundManager";
import {PearHarborGuiButtons} from "../components/gui/PearHarborGuiButtons";
import {PearlHarborToggleState} from "../components/gui/PearlHarborToggleStateSet";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {PearlHarborGameConfig} from "../PearlHarborGameConfig";
import {BetFeature} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";

export class PearlHarborForeground extends PIXI.Container implements StageLayer {

    private boostButton: PearHarborGuiButtons;
    private betBoostAllowed: boolean = false;
    private betBoostPaused: boolean = false;
    private _hasBoostedBet: boolean = false;
    private _isIdling: boolean = false;

    private _loopTl: TimelineLite | null;
    private _idleTimeline: TimelineLite | null;
    private _idleButtonTimeline: TimelineLite | null;
    private _boostAnimation1: PIXI.Sprite;
    private _boostAnimation2: PIXI.Sprite;

    public get boostedBet(): boolean {
        return this._hasBoostedBet;
    }

    constructor() {
        super();
        this.name = "BoostBet";
        this.init();
        this._hasBoostedBet = false;
    }

    private createBoostButton() {
        const colorSet: PointerStateColorSet = new PointerStateColorSet(
            0xFFFFFFFF,
            0xFFFFFFFF,
            0xFFFFFFFF,
            0xFFFFFFFF
        );
        this.boostButton = new PearHarborGuiButtons("boost",
            new PointerStateIconSet(
                new Icon(PearlHarbor.assetLoader.getTextures(PearlHarborGameAssets.BOOST_BUTTON_ON_1)[0]),
                undefined, undefined,
                new Icon(PearlHarbor.assetLoader.getTextures(PearlHarborGameAssets.BOOST_BUTTON_ON_1)[0]),
                //new Icon(PearlHarbor.assetLoader.getTextures(PearlHarborGameAssets.BOOST_BUTTON_ON_DISABLED)[0]),
            ),
            new PointerStateIconSet(
                new Icon(PearlHarbor.assetLoader.getTextures(PearlHarborGameAssets.BOOST_BUTTON_ON_2)[0]),
                undefined, undefined,
                new Icon(PearlHarbor.assetLoader.getTextures(PearlHarborGameAssets.BOOST_BUTTON_ON_2)[0])
            ), new PointerStateIconSet(
                new Icon(PearlHarbor.assetLoader.getTextures(PearlHarborGameAssets.BOOST_BUTTON_OFF)[0]),
                undefined, undefined,
                new Icon(PearlHarbor.assetLoader.getTextures(PearlHarborGameAssets.BOOST_BUTTON_OFF)[0])
            ), () => this.boostToggle());

        this.boostButton.addClickCallback(() => this.boostToggle());
        this.boostButton.toggled = PearlHarborToggleState.OFF;
        this.boostButton.enable(false);
        this.boostButton.position.set(0, 0);

        this.addChild(this.boostButton);
    }

    private createBoostAnimations() {
        this._boostAnimation1 = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("banzai_frame")[0]);
        this._boostAnimation1.name = "boostAnimation1";
        this._boostAnimation1.alpha = 0;
        this._boostAnimation1.visible = false;
        this._boostAnimation1.anchor.set(0.5);
        this._boostAnimation1.position.set(430, 448);

        this._boostAnimation2 = new PIXI.Sprite(PearlHarbor.assetLoader.getTextures("banzai_frame")[0]);
        this._boostAnimation2.name = "boostAnimation2";
        this._boostAnimation2.alpha = 0;
        this._boostAnimation2.visible = false;
        this._boostAnimation2.anchor.set(0.5);
        this._boostAnimation2.position.set(58, 448);
        NolimitApplication.getLayerByName(PearlHarborGameConfig.LAYERS.OVERLAY)!.addChild(this._boostAnimation1, this._boostAnimation2);
    }

    private init(): void {
        PearlHarbor.apiPlugin.freeBets.events.on(PearlHarbor.apiPlugin.freeBets.FREE_BETS_START, () => {
            this.turnOffBoost(true);
            PearlHarbor.apiPlugin.freeBets.events.once(PearlHarbor.apiPlugin.freeBets.FREE_BETS_END, () => {
                this.turnOffBoost(false);
            });
        });

        this.betBoostAllowed = PearlHarbor.apiPlugin.gameClientConfiguration.boostedBetAllowed;
        if (this.betBoostAllowed) {
            this.createBoostButton();
            this.createBoostAnimations();
        }
    }

    public setMode(mode: string) {
        if (mode == GameMode.NORMAL) {
            this.showBoostButton();
        } else {
            this.hideBoostButton();
        }
    }

    public showMiddleScatterBoostAnimation() {
        const fs: number = 0.033;
        this._boostAnimation1.visible = true;
        if (this._idleTimeline) {
            if (this._idleTimeline.isActive()) {
                this._idleTimeline.pause();
                this._idleTimeline.kill();
            }
            this._idleTimeline = null;
        }
        if (this._loopTl) {
            if (this._loopTl.isActive()) {
                this._loopTl.pause();
                this._loopTl.kill();
            }
            this._loopTl = null;
        }
        this._loopTl = new TimelineLite({repeat: -1, paused: true})
            .add(TweenLite.fromTo(this._boostAnimation1, 15 * fs, {alpha: 0}, {alpha: 1}))
            .add(TweenLite.fromTo(this._boostAnimation1, 15 * fs, {alpha: 1}, {alpha: 1}))
            .add(TweenLite.fromTo(this._boostAnimation1, 15 * fs, {alpha: 1}, {alpha: 0}));
        const startTl = new TimelineLite().add([
            TweenLite.fromTo(this._boostAnimation1.scale, 6 * fs, {x: 1.5, y: 1.5}, {x: 1, y: 1}),
            TweenLite.fromTo(this._boostAnimation1, 6 * fs, {alpha: 0}, {alpha: 1})
        ]);
        new TimelineLite().add(startTl).add(() => {
            this._loopTl!.play();
        });
    }

    private getNonActiveAreaSymPositions(): number[] {
        const possiblePos: number[][] = [[0, 0], [0, 1], [0, 2], [0, 3], [0, 4], [0, 5], [0, 6],
                [1, 0], [1, 1], [1, 2], [1, 3], [1, 4], [1, 5], [1, 6],
                [2, 0], [2, 1], [2, 5], [2, 6],
                [3, 0], [3, 1], [3, 5], [3, 6],
                [4, 0], [4, 1], [4, 5], [4, 6],
                [5, 0], [5, 1], [5, 2], [5, 3], [5, 4], [5, 5], [5, 6],
                [6, 0], [6, 1], [6, 2], [6, 3], [6, 4], [6, 5], [6, 6]],
            possiblePosLength: number = possiblePos.length,
            randomPos: number[] = possiblePos[Math.floor(Math.random() * possiblePosLength)];

        return [58 + randomPos[0] * PearlHarborGameConfig.symbolWidth, 160 + randomPos[1] * PearlHarborGameConfig.symbolHeight];
    }

    private showNonActiveAreaScatterBoostAnimation() {
        const fs: number = 0.033;
        this._boostAnimation1.visible = true;
        this._boostAnimation2.visible = true;
        const startTl: TimelineLite = new TimelineLite().add([
            TweenLite.fromTo(this._boostAnimation2.scale, 6 * fs, {x: 1.5, y: 1.5}, {x: 1, y: 1}),
            TweenLite.fromTo(this._boostAnimation2, 6 * fs, {alpha: 0}, {alpha: 1})
        ]);

        if (this._idleTimeline) {
            if (this._idleTimeline.isActive()) {
                this._idleTimeline.pause();
                this._idleTimeline.kill();
            }
            this._idleTimeline = null;
        }

        if (this._loopTl) {
            if (this._loopTl.isActive()) {
                this._loopTl.pause();
                this._loopTl.kill();
            }
            this._loopTl = null;
        }

        this._loopTl = new TimelineLite({repeat: -1, paused: true}).add([
            () => {
                const pos: number[] = this.getNonActiveAreaSymPositions();
                this._boostAnimation2.position.set(pos[0], pos[1])
            },
            TweenLite.fromTo(this._boostAnimation2, 15 * fs, {alpha: 0}, {alpha: 1}),
            TweenLite.fromTo(this._boostAnimation1, 15 * fs, {alpha: 0}, {alpha: 1})
        ]).add([
            TweenLite.fromTo(this._boostAnimation2, 15 * fs, {alpha: 1}, {alpha: 1})
        ]).add([
            TweenLite.fromTo(this._boostAnimation2, 15 * fs, {alpha: 1}, {alpha: 0}),
            TweenLite.fromTo(this._boostAnimation1, 15 * fs, {alpha: 1}, {alpha: 0})
        ]);
        new TimelineLite().add(startTl).add(() => {
            this._loopTl!.play();
        })
    }

    public enableButton(value: boolean = false) {
        if (!this.betBoostAllowed || this.betBoostPaused) {
            return;
        }
       /* if (value) {
            PearlHarbor.foregroundElements.startIdle();
        } else {
            PearlHarbor.foregroundElements.stopIdle();
        }*/
        this.boostButton.enable(value);
    }

    public showBoostButton() {
        if (!this.boostButton) {
            return;
        }
        this.boostButton.visible = true;
    }

    public showBoostButtonOnRestore(state: PearlHarborToggleState) {
        this._hasBoostedBet = false;
        if (!this.boostButton) {
            return;
        }
        this.boostButton.visible = true;
        if (!this.betBoostAllowed || this.betBoostPaused) {
            return;
        }
        if (state === PearlHarborToggleState.ON1) {
            this.boostButton.toggled = PearlHarborToggleState.ON1;
            const featureData = PearlHarbor.apiPlugin.bonusFeatures.getFeatureDataByName("BOOSTED_BET");
            if (featureData) {
                let data: BetBoostData = {
                    featureName: featureData.name,
                    price: featureData.price
                }

                PearlHarbor.apiPlugin.betHandler.setBoost(data);
            }
            this._hasBoostedBet = true;
        } else if (state === PearlHarborToggleState.ON2) {
            this.boostButton.toggled = PearlHarborToggleState.ON2;
            const featureData = PearlHarbor.apiPlugin.bonusFeatures.getFeatureDataByName("BOOSTED_BET_2");
            if (featureData) {
                let data: BetBoostData = {
                    featureName: featureData.name,
                    price: featureData.price
                }

                PearlHarbor.apiPlugin.betHandler.setBoost(data);
            }
            this._hasBoostedBet = true;
        } else {
            this.boostButton.toggled = PearlHarborToggleState.OFF;
            PearlHarbor.apiPlugin.betHandler.setBoost(undefined);
        }
    }

    public hideBoostButton() {
        if (!this.boostButton) {
            return;
        }
        this.boostButton.visible = false;
    }

    public turnOffBoost(pauseBoost: boolean) {
        if (!this.betBoostAllowed) {
            return;
        }
        if (PearlHarbor.apiPlugin.betHandler.betBoost != undefined) {
            if (PearlHarbor.model.buyFeatureName == "BOOSTED_BET" || PearlHarbor.model.buyFeatureName == "BOOSTED_BET_2") {
                PearlHarbor.model.buyFeatureName = "";
            }
            if (this._loopTl) {
                if (this._loopTl.isActive()) {
                    this._loopTl.pause();
                    this._loopTl.kill();
                }
            }
            this.boostButton.enable(false);
            this._boostAnimation1.alpha = 0;
            this._boostAnimation1.scale.set(1);
            this._boostAnimation2.alpha = 0;
            this._boostAnimation2.scale.set(1);
            if(PearlHarbor.model.buyFeatureName === ""){
                PearlHarbor.apiPlugin.betHandler.setBoost(undefined);
            }
            this.boostButton.toggled = PearlHarborToggleState.OFF;
        }
        this.betBoostPaused = pauseBoost;
        this.stopIdle();
    }

    public setBoostState() {
        if (!this.boostButton) {
            return;
        }
        const featureData: BetFeature | undefined = PearlHarbor.apiPlugin.betFeatureController.getActiveBetFeature();

        if (featureData) {
            if (featureData.name === "BOOSTED_BET") {
                this.boostButton.toggled = PearlHarborToggleState.ON1;
            } else if (featureData.name === "BOOSTED_BET_2") {
                this.boostButton.toggled = PearlHarborToggleState.ON2;
            } else {
                PearlHarbor.apiPlugin.betFeatureController.setActiveBetFeature(featureData.name);
                this.boostButton.toggled = PearlHarborToggleState.OFF;
            }
        } else {
            PearlHarbor.apiPlugin.betFeatureController.setActiveBetFeature();
            this.boostButton.toggled = PearlHarborToggleState.OFF;
        }


    }

    private boostToggle(playSound: boolean = true) {
        this._hasBoostedBet = false;
        if (!this.betBoostAllowed || this.betBoostPaused) {
            return;
        }
        if (this.boostButton.toggled === PearlHarborToggleState.OFF) {
            this.boostButton.toggled = PearlHarborToggleState.ON1;

            PearlHarbor.apiPlugin.betFeatureController.setActiveBetFeature("BOOSTED_BET");
            this._hasBoostedBet = true;
            this.showMiddleScatterBoostAnimation();
            this.stopIdle();
        } else if (this.boostButton.toggled === PearlHarborToggleState.ON1) {
            this.boostButton.toggled = PearlHarborToggleState.ON2;
            PearlHarbor.apiPlugin.betFeatureController.setActiveBetFeature("BOOSTED_BET_2");
            this._hasBoostedBet = true;
            this.showNonActiveAreaScatterBoostAnimation();
            this.stopIdle();
        } else {
            PearlHarbor.model.buyFeatureName = "";
            if (this._loopTl) {
                if (this._loopTl.isActive()) {
                    this._loopTl.pause();
                    this._loopTl.kill();
                }
            }
            this._boostAnimation1.visible = false;
            this._boostAnimation2.visible = false;
            this._boostAnimation1.alpha = 0;
            this._boostAnimation2.alpha = 0;
            this._boostAnimation1.scale.set(1);
            this._boostAnimation2.scale.set(1);
            this.boostButton.toggled = PearlHarborToggleState.OFF;

            PearlHarbor.apiPlugin.betHandler.setBoost(undefined);
            this.startIdle();
        }

        if (playSound) {
            if (this.boostButton.toggled === PearlHarborToggleState.OFF) {
                PearlHarborSoundManager.stopBoostOffSound();
                PearlHarborSoundManager.stopBoostOnSound();
                PearlHarborSoundManager.playBoostOffSound();
            } else {
                PearlHarborSoundManager.stopBoostOnSound();
                PearlHarborSoundManager.stopBoostOffSound();
                PearlHarborSoundManager.playBoostOnSound(this.boostButton.toggled === PearlHarborToggleState.ON1);
            }
        }
    }

    public startAnimationOnIdle(): void {
        const startAnimationTime: number = this._boostAnimation1.visible ? 7 : 1;
        if (this._idleTimeline) {
            if (this._idleTimeline.isActive()) {
                this._idleTimeline.pause();
                this._idleTimeline.kill();
            }
            this._idleTimeline = null;
        }
        this._idleTimeline = new TimelineLite();
        this._idleTimeline.add(() => {
            PearlHarbor.foregroundElements.startAnimation();
        }, startAnimationTime);
    }

    public startAnimation(): void {
        if (!this.boostButton) {
            return;
        }
        if (this.boostButton.toggled === PearlHarborToggleState.OFF) {
            return;
        }
        if (this._idleTimeline) {
            if (this._idleTimeline.isActive()) {
                this._idleTimeline.pause();
                this._idleTimeline.kill();
            }
            this._idleTimeline = null;
        }

        if (this._loopTl) {
            if (this._loopTl.isActive()) {
                return;
            }
        }

        if (this.boostButton.toggled === PearlHarborToggleState.ON1) {
            this.showMiddleScatterBoostAnimation();
        }

        if (this.boostButton.toggled === PearlHarborToggleState.ON2) {
            this.showNonActiveAreaScatterBoostAnimation();
        }
    }

    public resetOnNewSpin(): void {
        if (this._idleTimeline) {
            if (this._idleTimeline.isActive()) {
                this._idleTimeline.pause();
                this._idleTimeline.kill();
            }
            this._idleTimeline = null;

            if (this._hasBoostedBet) {
                this.startAnimation();
            }
        }
    }

    public hideBoostAnimationOnAvalanche(): void {
        this._boostAnimation1.visible = false;
        this._boostAnimation2.visible = false;
    }

    public stopBoostAnimation(scatterPos: number = -1): void {
        if (!this.boostButton) {
            return;
        }
        if (this.boostButton.toggled === PearlHarborToggleState.OFF) {
            return;
        }

        if (this.boostButton.toggled === PearlHarborToggleState.ON1) {
            if (this._loopTl) {
                if (this._loopTl.isActive()) {
                    this._loopTl.pause();
                    this._loopTl.kill();
                }
                this._loopTl = null;
            }

            this._boostAnimation1.alpha = 1;
            this._boostAnimation1.scale.set(1);
        } else if (this.boostButton.toggled === PearlHarborToggleState.ON2) {

            if (this._boostAnimation1.visible || this._boostAnimation2.visible) {
                if (this._loopTl) {
                    if (this._loopTl.isActive()) {
                        this._loopTl.pause();
                        this._loopTl.kill();
                    }
                }
            }
            if (scatterPos === 48) {
                this._boostAnimation1.alpha = 1;
                this._boostAnimation1.scale.set(1);
            } else {
                this._boostAnimation2.position.set(58 + Math.floor(scatterPos / 14) * PearlHarborGameConfig.symbolWidth, 160 + (scatterPos % 14) * PearlHarborGameConfig.symbolHeight * 0.5);
                this._boostAnimation2.alpha = 1;
                this._boostAnimation2.scale.set(1);
            }
        }
    }

    public startIdle(): void {
        if (!this.boostButton) {
            return;
        }
        if (this.boostButton.toggled === PearlHarborToggleState.OFF) {
            this._isIdling = true;
            this.playIdleLoop();
        }
    }

    private playIdleLoop(startTime: number = 5): void {
        if (!this._isIdling) {
            return;
        }

        if (!this.boostButton) {
            return;
        }

        if (this._idleButtonTimeline) {
            if (this._idleButtonTimeline.isActive()) {
                this._idleButtonTimeline.pause();
                this._idleButtonTimeline.kill();
            }
            this._idleButtonTimeline = null;
        }
        if (this.boostButton.toggled !== PearlHarborToggleState.OFF) {
            return;
        }
        this._idleButtonTimeline = gsap.timeline();
        this._idleButtonTimeline.add(() => {
            this.boostButton.playIdle();
            this.playIdleLoop((startTime >= 20 ? 5 : startTime) + 5);
        }, startTime);
    }

    public stopIdle(): void {
        if (!this._isIdling) {
            return;
        }
        if (!this.boostButton) {
            return;
        }
        this._isIdling = false;
        if (this._idleButtonTimeline && this._idleButtonTimeline.isActive()) {
            this._idleButtonTimeline.pause();
            this._idleButtonTimeline.kill();
        }
        this._idleButtonTimeline = null;
        this.boostButton.stopIdle();
    }
}